module.exports = __webpack_public_path__ + "img/ed41a91.png";